import { ReminderActions } from '../actions/actionTypes'
import keys from '../components/txtkeys/premiumReminderKeys'
import { IReminderSettings, IRemindersStore, RepeatInterval } from '../Interfaces/ReminderSettingsInterface'
import { l, ml } from '../Other/Translation'
import { ReducerBuilder } from './ReducerBuilder'

const initialState: IRemindersStore = {
  loaded: false,
  settings: {
    activationDate: new Date().toISOString(),
    createNotification: true,
    afterDueDate: {
      active: false,
      emailBody: keys.settings.afterDueDateBody,
      emailSubject: keys.settings.afterDueDateSubject,
      nDays: 7,
      repeat: RepeatInterval.once,
    },
    onDueDate: {
      active: false,
      emailBody: keys.settings.onDueDateBody,
      emailSubject: keys.settings.onDueDateSubject,
    },
    beforeDueDate: {
      active: false,
      emailBody: keys.settings.beforeDueDateBody,
      emailSubject: keys.settings.beforeDueDateSubject,
      nDays: 1,
    },
    postAfterDueDate: {
      active: false,
      coverLetter: keys.settings.postAfterDueDateLetter,
      coverTitle: keys.settings.postAfterDueDateTitle,
      nDays: 30,
    },
  },
}

const setSettings = (state: IRemindersStore, payload: IReminderSettings): IRemindersStore => ({
  loaded: true,
  settings:
    payload ||
    (state.loaded
      ? state.settings
      : {
          ...state.settings,
          afterDueDate: {
            ...state.settings.afterDueDate,
            emailBody: ml(state.settings.afterDueDate.emailBody),
            emailSubject: l(state.settings.afterDueDate.emailSubject),
          },
          onDueDate: {
            ...state.settings.onDueDate,
            emailBody: ml(state.settings.onDueDate.emailBody),
            emailSubject: l(state.settings.onDueDate.emailSubject),
          },
          beforeDueDate: {
            ...state.settings.beforeDueDate,
            emailBody: ml(state.settings.beforeDueDate.emailBody),
            emailSubject: l(state.settings.beforeDueDate.emailSubject),
          },
          postAfterDueDate: {
            ...state.settings.postAfterDueDate,
            coverLetter: state.settings.postAfterDueDate.coverLetter,
            coverTitle: state.settings.postAfterDueDate.coverTitle,
          },
        }),
})

export default new ReducerBuilder<IRemindersStore, IReminderSettings>(initialState)
  .mapAction(ReminderActions.LOAD_REMINDER_SETTINGS, setSettings)
  .mapAction(ReminderActions.UPDATE_REMINDER_SETTINGS, setSettings)
  .build()
